import React from 'react'
import FontAwesome from 'react-fontawesome';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { Form, Button, Modal } from 'react-bootstrap';
import { connectModal } from 'redux-modal';
import * as validators from 'misc/validators';
import { FILE_UPDATE_MODAL, FILE_UPDATE_FORM } from 'misc/constants';
import { isFileUpdateModalLoading } from 'selectors/loading';
import Spinner from 'components/core/Spinner';
import CharField from 'components/core/CharField';
import PureRenderComponent from 'components/core/PureRenderComponent';
import SingleDropzoneField from 'components/core/SingleDropzoneField';


class FileUpdateModal extends PureRenderComponent {

  componentDidUpdate(prevProps) {
    if (this.props.file && this.props.file !== prevProps.file) {
      const { file } = this.props;
      this.props.change('name', file.name)
    }
  }

  render() {
    const {
      show,
      title,
      invalid,
      isLoading,
      handleHide,
      handleSubmit,
      handleUpdate
    } = this.props;

    return (
      <Modal
        show={show}
        onHide={handleHide}
        animation={true}
        backdrop="static">
        <Form
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit(handleUpdate)}>
          <Modal.Header closeButton>
            <Modal.Title>Update {title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="file-upload-modal no-padding">
            <Field
              name="file"
              component={SingleDropzoneField} />
            <div className="p-10">
              <Field
                name="name"
                label="Name"
                type="text"
                validate={[
                  validators.required,
                  validators.maxLength150,
                ]}
                isRequired={true}
                component={CharField.Labeled} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="pull-left"
              bsSize="sm"
              type="button"
              onClick={handleHide}>
              <FontAwesome name="close" className="mr-5" />Close
            </Button>
            <Button
              bsStyle="primary"
              bsSize="sm"
              type="submit"
              disabled={invalid}>
              <FontAwesome name="paper-plane-o" className="mr-5" />Submit
            </Button>
          </Modal.Footer>
        </Form>
        <Spinner isLoading={isLoading} />
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const formSelector = formValueSelector(FILE_UPDATE_FORM);
  const file = formSelector(state, 'file');
  return {
    file,
    isLoading: isFileUpdateModalLoading(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    change,
  }, dispatch)
}

FileUpdateModal = connectModal({
  name: FILE_UPDATE_MODAL
})(FileUpdateModal);

FileUpdateModal = reduxForm({
  form: FILE_UPDATE_FORM
})(FileUpdateModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileUpdateModal);
